
import React from "react";
// react plugin used to create charts
import { Line, Pie } from "react-chartjs-2";
// reactstrap components
import axios from "axios";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col, Button
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// core components
import { PieChart } from 'react-minimal-pie-chart';
import Chart from "react-google-charts";

import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      orderCount: 0,
      orderCountOutlet: 0,
      customer_count: 0,
      confirmation_time: 0,
      dispatch_time: 0,
      user_type: "",
      salesData: [],
      timeData: []
    };
  }
  componentDidMount() {
    let userType = localStorage.getItem("userType") === 'outlet_staff' ? 'staff' : 'admin';
    this.setState({
      user_type: userType
    })
    if (userType === "admin") {
      this.fetchOrders();
    }
    else {
      this.fetchOutletOrders();
    }
  }
  fetchOrders = () => {
    const access = sessionStorage.getItem('access');
    axios({
      method: 'get',
      url: 'https://api.chicking-malappuram.in/api/dashboard',
    }).then((res) => {
      console.log(res.data)
      this.setState({
        orderCount: res.data.order_count,
        totalAmount: res.data.total,
        customer_count: res.data.customer_count,
        salesData: res.data.salesData,
        timeData: res.data.timeData,
      })
    });
  }
  fetchOutletOrders = () => {
    const access = sessionStorage.getItem('access');
    axios({
      method: 'get',
      url: 'https://api.chicking-malappuram.in/api/dashboard-outlet',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer' + ' ' + access,
      }
    }).then((res) => {
      console.log(res.data)
      this.setState({
        orderCountOutlet: res.data.orders,
        confirmation_time: res.data.confirm_time,
        dispatch_time: res.data.dispatch_time,
      })
    });
  }
  render() {
    return (
      <>
        <div className="content">
          {this.state.user_type === "admin" ?
            <div className="admin-content">
              <Row>
                <Col lg="4" md="6" sm="6">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col md="4" xs="5">
                          <div className="icon-big text-center icon-warning">
                            <i className="nc-icon nc-cart-simple text-warning" />
                          </div>
                        </Col>
                        <Col md="8" xs="7">
                          <div className="numbers">
                            <p className="card-category">Orders</p>
                            <CardTitle tag="p">{this.state.orderCount}</CardTitle>
                            <p />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr />
                      <div className="stats">
                        <i className="far fa-calendar" /> Today
                  </div>
                    </CardFooter>
                  </Card>
                </Col>
                <Col lg="4" md="6" sm="6">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col md="4" xs="5">
                          <div className="icon-big text-center icon-warning">
                            <i className="nc-icon nc-money-coins text-success" />
                          </div>
                        </Col>
                        <Col md="8" xs="7">
                          <div className="numbers">
                            <p className="card-category">Revenue</p>
                            <CardTitle tag="p">INR {this.state.totalAmount}</CardTitle>
                            <p />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr />
                      <div className="stats">
                        <i className="far fa-calendar" />Today
                  </div>
                    </CardFooter>
                  </Card>
                </Col>
                <Col lg="4" md="6" sm="6">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col md="4" xs="5">
                          <div className="icon-big text-center icon-warning">
                            <i className="nc-icon nc-circle-10 text-primary" />
                          </div>
                        </Col>
                        <Col md="8" xs="7">
                          <div className="numbers">
                            <p className="card-category">Customers</p>
                            <CardTitle tag="p">{this.state.customer_count}</CardTitle>
                            <p />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr />
                      <div className="stats">
                        <i className="far fa-clock" /> total
                      <div className="pull-right">
                          <a target="blank" href="https://api.chicking-malappuram.in/customer-sheet">Export to Excel</a>
                        </div>
                      </div>

                    </CardFooter>
                  </Card>
                </Col>

              </Row>
              <Row>
                <Col md="5">
                  <Card className="card-stats">
                    <Chart
                      width={'100%'}
                      height={'400px'}
                      chartType="PieChart"
                      loader={<div>Loading Chart</div>}
                      data={this.state.salesData}
                      options={{
                        title: 'Sales by outlet',
                      }}
                      rootProps={{ 'data-testid': '1' }}
                    />
                  </Card>
                </Col>
                <Col md="7">
                  <Card className="card-stats" style={{ padding: 15 }}>
                    <Chart
                      width={'100%'}
                      height={'370px'}
                      chartType="Bar"
                      loader={<div>Loading Chart</div>}
                      data={this.state.timeData}
                      options={{
                        // Material design options
                        chart: {
                          title: 'Outlet Performance',
                          subtitle: 'Order confirmation and dispatch summary',
                        },
                      }}
                      // For tests
                      rootProps={{ 'data-testid': '2' }}
                    />
                  </Card>
                </Col>
              </Row>

              <a className="btn new-order-button" href="/portal/orders" >New Order</a>
            </div>
            :
            <Row>
              <Col lg="4" md="6" sm="6">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <Col md="4" xs="5">
                        <div className="icon-big text-center icon-warning">
                          <i className="nc-icon nc-cart-simple text-warning" />
                        </div>
                      </Col>
                      <Col md="8" xs="7">
                        <div className="numbers">
                          <p className="card-category">Orders</p>
                          <CardTitle tag="p">{this.state.orderCountOutlet}</CardTitle>
                          <p />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <hr />
                    <div className="stats">
                      <i className="far fa-calendar" /> Today
              </div>
                  </CardFooter>
                </Card>
              </Col>
              <Col lg="4" md="6" sm="6">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <Col md="12" xs="7">
                        <div className="numbers">
                          <p className="card-category">Confirmation Time</p>
                          <CardTitle tag="p">{this.state.confirmation_time} minutes</CardTitle>
                          <p />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <hr />
                    <div className="stats">
                      <i className="far fa-calendar" />Today
              </div>
                  </CardFooter>
                </Card>
              </Col>
              <Col lg="4" md="6" sm="6">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <Col md="12" xs="7">
                        <div className="numbers">
                          <p className="card-category">Avg Dispatch Time</p>
                          <CardTitle tag="p">{this.state.dispatch_time} minutes</CardTitle>
                          <p />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <hr />
                    <div className="stats">
                      <i className="far fa-clock" /> Today
              </div>
                  </CardFooter>
                </Card>
              </Col>

            </Row>


          }
        </div>
      </>
    );
  }
}

export default Dashboard;
